
 <template>
    <div class="layout-topbar">
      <div class="layout-topbar-menu gap-2">
        <button @click="toggleTheme" class="p-link layout-topbar-button surface-ground">
          <i :class="themeIcon" style="font-size: 1.25rem"></i>
        </button>
        <button @click="logout" class="p-link layout-topbar-button surface-ground">
          <i class="pi pi-power-off hover:text-white" style="font-size: 1.25rem"></i>
        </button>
        <button v-if="menuEntries.length" @click="navigate(menuEntries[9].to)" class="p-link layout-topbar-button surface-ground">
          <i class="pi pi-cog hover:text-white" style="font-size: 1.25rem"></i>
        </button>
        <div v-if="userIsLogged" class="flex justify-content-center align-items-center">
          <Avatar :image="authStore.getUserProfilePhoto()" class="p-link layout-topbar-button" style="width: 48px; height: 48px; cursor: default;" shape="circle" />
        </div>
      </div>
      <router-link to="/" class="layout-topbar-logo flex-row-reverse">
        <img src="@/assets/logo.png" alt="logo" class="logo-bg" />
      </router-link>
      <button class="p-link layout-topbar-menu-button layout-topbar-button" @click="onTopBarMenuButton()">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </div>
  </template>
  
  <script setup>
  import Avatar from 'primevue/avatar';
  import { ref, computed, onMounted } from 'vue';
  import { useAuthStore } from '@/stores/auth';
  import menuHelper from '@/helpers/MenuHelper';
  import { useI18n } from 'vue-i18n';
  import { useConfirm } from 'primevue/useconfirm';
  import router from '@/router/router';
  import { usePrimeVue } from 'primevue/config';
  import { useThemeStore } from '@/helpers/theme';
  
  const authStore = useAuthStore();
  const themeStore = useThemeStore();
  const i18n = useI18n();
  const confirm = useConfirm();
  const $primevue = usePrimeVue();
  
  const menuEntries = ref([]);
  const isDarkTheme = computed(() => themeStore.isDarkTheme);
  
  const themeIcon = computed(() => (isDarkTheme.value ? 'pi pi-sun' : 'pi pi-moon'));

  onMounted(() => {
    menuHelper.makeSideMenu(authStore.amIAdmin()).forEach(e => menuEntries.value.push(e));
    applyTheme();
  });

  
  const userIsLogged = computed(() => authStore.userIsLogged());
  
  const navigate = (url) => {
    if (url) {
      setTimeout(() => {
        router.push(url);
      }, 500);
    }
  };
  
  const logout = () => {
    confirm.require({
      header: i18n.t('CONFIRMATION_HEADER'),
      message: i18n.t('LOGOUT_CONFIRM_MESSAGE'),
      acceptLabel: i18n.t('YES'),
      rejectLabel: i18n.t('NO'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        authStore.logout();
      }
    });
  };
  
  const toggleTheme = () => {
    themeStore.toggleTheme();
    applyTheme();
  };
  
  const applyTheme = () => {
    const currentTheme = isDarkTheme.value ? 'md-dark-indigo' : 'md-light-indigo';
    const newTheme = isDarkTheme.value ? 'md-light-indigo' : 'md-dark-indigo';
    $primevue.changeTheme(currentTheme, newTheme, 'theme-link', () => {
      isDarkTheme.value = !isDarkTheme.value;
    });
  };
  </script>
  
  <style lang="scss" scoped>
  :deep(.p-button .p-confirm-dialog-reject) {
    display: none;
  }
  
  .logo-bg {
    background-color: var(--surface-logo);
    border-radius: 50%;
  }
  </style>
  